import { getCookie, setCookie } from "../helpers";

export function gtmClickAction() {
  const buttons = document.querySelectorAll(
    "[data-gtm-name]",
  ) as NodeListOf<HTMLElement>;
  buttons?.forEach((button) => {
    const cookieName = "gmtUserAnalyticID";
    button.addEventListener("click", function () {
      const cookieAattr = this.getAttribute("data-gtm-user-id");
      if (cookieAattr) {
        const cookie = getCookie(cookieName);
        console.log(cookie);
        if (cookie === null) {
          const date = new Date();
          date.setDate(date.getDate() + 1);
          setCookie(cookieName, cookieAattr, {
            expires: date,
            domain: ".sportsengineplay.com",
          });
        }
      }
      const name = this.getAttribute("data-gtm-name");
      const type = this.getAttribute("data-gtm-type");
      const args = this.getAttribute("data-gtm-args");
      gtag(type, name, JSON.parse(args));
    });
  });
}
